export const APP_CONFIG = {
  NAME: 'HB Furniture',
  TAGLINE: 'Premium Furniture Rentals in Pune',
  LOCATION: 'Pune, Maharashtra',
  PHONE: '+91 98765 43210',
  EMAIL: 'support@hbfurniture.com',
  SUPPORT_HOURS: 'Mon-Sat: 9 AM - 7 PM'
};

export const ROUTES = {
  HOME: '/',
  PRODUCTS: '/products',
  PRODUCTS_CATEGORY: '/products/:category',
  PRODUCT_DETAIL: '/product/:id',
  CART: '/cart',
  CHECKOUT: '/checkout'
};

export const API_ENDPOINTS = {
  PRODUCTS: '/products',
  PRODUCT_BY_ID: '/products/:id',
  CATEGORIES: '/categories',
  ORDERS: '/orders',
  USERS: '/users'
};

export const STORAGE_KEYS = {
  CART: 'hbfurniture_cart',
  WISHLIST: 'hbfurniture_wishlist',
  USER: 'hbfurniture_user',
  LOCATION: 'hbfurniture_location'
};

export const TENURE_OPTIONS = [6, 9, 12, 18, 24];
export const DEFAULT_TENURE = 6;
export const DEPOSIT_PERCENTAGE = 0.2;

export const PRICE_RANGES = [
  { label: 'Under ₹500', min: 0, max: 500 },
  { label: '₹500 - ₹1000', min: 500, max: 1000 },
  { label: '₹1000 - ₹2000', min: 1000, max: 2000 },
  { label: 'Above ₹2000', min: 2000, max: Infinity }
];

export const BUDGET_RANGES = [
  { id: 'budget-1', label: 'Under ₹10,000', min: 0, max: 10000 },
  { id: 'budget-2', label: '₹10,000 - ₹25,000', min: 10000, max: 25000 },
  { id: 'budget-3', label: '₹25,000 - ₹50,000', min: 25000, max: 50000 },
  { id: 'budget-4', label: 'Above ₹50,000', min: 50000, max: Infinity }
];

export const SORT_OPTIONS = [
  { value: 'popular', label: 'Most Popular' },
  { value: 'price-low', label: 'Price: Low to High' },
  { value: 'price-high', label: 'Price: High to Low' },
  { value: 'rating', label: 'Highest Rated' },
  { value: 'newest', label: 'Newest First' }
];
